
import global from '../../../static/js/global'
import loadPage from '../../components/loadingPage'
import Group from 'vux/src/components/group/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Alert from 'vux/src/components/alert/index.vue'

export default {
data() {
return {
iconType: "",

show_1:false,
pkCode:"",//车位编号
carNo:"",//车牌号码
carName:"",//车主姓名
carBrand:"",//车辆品牌
carModel:"",//车辆型号
carColor:"",//车身颜色
carPhone:'',//绑定手机
comnCode:'',//
pkId:'',
showprompt:false,
prompt:'',
carId:'',
openid:'',
disableBtn:false
}
},
components: {
Group,
Flexbox,
XHeader,
XInput,
XButton,
FlexboxItem,
loadPage,
Alert
},
beforeMount(){
this.carPhone = this.$router.history.current.query.phone;
if(this.$router.history.current.path == "/myCarInfo"){
document.title = "添加车辆";
}
this.pkCode=this.$router.history.current.query.pkCode;
this.phone=this.$router.history.current.query.phone;
this.pkId=this.$router.history.current.query.pkId;
this.openid=this.$router.history.current.query.openid;
},
methods: {
onBlur(val) {
console.log("on blur", val);
},
validateCarNo(){
let carStr = /(^[\u4E00-\u9FA5]{1}[A-Z0-9]{6}$)|(^[A-Z]{2}[A-Z0-9]{2}[A-Z0-9\u4E00-\u9FA5]{1}[A-Z0-9]{4}$)|(^[\u4E00-\u9FA5]{1}[A-Z0-9]{5}[挂学警军港澳]{1}$)|(^[A-Z]{2}[0-9]{5}$)|(^(08|38){1}[A-Z0-9]{4}[A-Z0-9挂学警军港澳]{1}$)/;
let carNos = this.carNo;
console.log(carNos);
let carNoNumber=carStr.test(carNos)
if(carStr.test(carNos)){
this.showprompt=false;
this.disableBtn=false;
return true;
}else{
this.showprompt=true;
this.prompt='请输入正确的车牌号码';
this.disableBtn=true;
return false;
}
},
changeCarInfo(){
let carStr = /(^[\u4E00-\u9FA5]{1}[A-Z0-9]{6}$)|(^[A-Z]{2}[A-Z0-9]{2}[A-Z0-9\u4E00-\u9FA5]{1}[A-Z0-9]{4}$)|(^[\u4E00-\u9FA5]{1}[A-Z0-9]{5}[挂学警军港澳]{1}$)|(^[A-Z]{2}[0-9]{5}$)|(^(08|38){1}[A-Z0-9]{4}[A-Z0-9挂学警军港澳]{1}$)/;
let carNos = this.carNo;
console.log(carNos);
let carNoNumber=carStr.test(carNos)
if(carStr.test(carNos)){
this.disableBtn=false;
return true;
}else{
this.disableBtn=true;
return false;
}
},
addCar() {
if(!this.validateCarNo()){
return ;
}

let omeinfo=new Object()
omeinfo.pkCode=this.pkCode;
omeinfo.carNo=this.carNo;
omeinfo.carName=this.carName;
omeinfo.carBrand=this.carBrand;
omeinfo.carModel=this.carModel;
omeinfo.carColor=this.carColor;
omeinfo.carPhone=this.$router.history.current.query.phone;
omeinfo.comnCode=this.$router.history.current.query.comnCode;
omeinfo.pkId=this.$router.history.current.query.pkId;
omeinfo.pkCode=this.$router.history.current.query.pkCode;
omeinfo.openid=this.$router.history.current.query.openid;



console.log(omeinfo)
this.show_1 = true;
let url1=global.host + 'carInfo/bindParkingInfo';

if(omeinfo.carNo===''){
this.showprompt = true;
this.prompt = "请填写完整的信息！";
this.show_1 = false
return;
}
console.log('@@@@@@@@@@@');
console.log(omeinfo);
console.log('@@@@@@@@@@@');
this.$http.post(url1,omeinfo).then(function(res){

let stateCode = res.body.statusCode;
if(stateCode == "110"){
this.$router.push({ path: "/myCarInfo",query:{phone:omeinfo.carPhone,comnCode:omeinfo.comnCode,pkId:omeinfo.pkId,pkCode:omeinfo.pkCode,openid:omeinfo.openid}});
}else if(stateCode == "120"){
this.showprompt = true;
this.prompt = "绑定失败,请重试！";
}
this.show_1 = false
},
function(err){
console.log(err)
})
}
}
};



// WEBPACK FOOTER //
// ./src/components/carRentComponents/addCar.vue